import React from "react";
import { AlertTriangle } from "lucide-react";


export const UnnotifiedLeadBadge = ({ status, recordId, context = "card" }) => {
  if (status !== "failed") return null;
  return (
    <span
      className="inline-flex max-w-full items-center gap-1 rounded border border-red-300 bg-red-50 px-2 py-1 text-[11px] font-extrabold text-red-700 shadow-sm"
      data-testid={`unnotified-lead-badge-${context}-${recordId}`}
      role="alert"
    >
      <AlertTriangle className="h-3.5 w-3.5 shrink-0" aria-hidden="true" />
      <span>UNNOTIFIED LEAD</span>
    </span>
  );
};